// extracted by mini-css-extract-plugin
module.exports = {"print":"PrintIcon__print___2FglF","tpb":"PrintIcon__tpb___z9L68"};